/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { sleep } from "./sleep";

/**
 * @typedef {Promise<any>} AnyPromise
 */

/**
 * @template {AnyPromise} P
 * @typedef {P extends Promise<infer R> ? R : never} PromiseOf
 */

/**
 * Waits at least a specified duration before resolving the given promise.
 *
 * @template {AnyPromise} P
 * @param {P} promise - Promise to wait for.
 * @param {number} [wait=350] - The duration to wait in milliseconds.
 * @returns {Promise<PromiseOf<P>>} - The result of the promsie.
 */
export async function waitAtLeast (promise, wait = 350) {
    const [result] = await Promise.all([promise, sleep(wait)]);
    return result;
}
